import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '@app-services/spinner/spinner.service';
import { MediaObserver } from '@angular/flex-layout';
import { INavigationBarItem } from '@shared/shared/shared.module';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs'; // , Subject, fromEvent
import { UIActions } from 'src/app/core/store/actions/ui/actions';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/store/app.reducers';
import { mainContentAnimation } from './components/sidebar/animations';
//import { getPermissionTypes } from '@app-core/store/actions';
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  animations: [mainContentAnimation()],
})
export class MainLayoutComponent implements OnInit {
  public customerLogo: string;
  public userAvatar: string;
  public scrollEnabled = true;

  // Side nav
  subscription: Subscription = new Subscription();
  sidebarToggle: boolean;
  public isOpen = false;
  sidenavMode: 'side' | 'over';
  sidebarState = 'open';

  showSidebar!: boolean;
  // MENU
  public navigationBarItems: INavigationBarItem[] = [
    // {
    //   path: '/orders',
    //   label: 'Order List',
    //   icon: 'local_activity',
    // },
    {
      path: '/referrals',
      label: 'Referrals',
      icon: 'account_box',
    },
    {
      path: '/requests',
      label: 'Requests',
      icon: 'domain',
    },
  ];

  constructor(
    public spinnerService: SpinnerService,
    public mediaObserver: MediaObserver,
    public breakpointObserver: BreakpointObserver,
    private store: Store<AppState>
  ) {
    this.subscription = this.store.select('ui').subscribe((event) => {
      if (event.sidebarOpen == 'mouseout') {
        this.sidebarToggle = false;
      } else if (event.sidebarOpen == 'mouseopen') {
        this.sidebarToggle = true;
      } else if (event.sidebarOpen == 'open') {
        this.sidebarToggle = true;
      } else {
        this.sidebarToggle = false;
      }
      this.sidebarState = event.sidebarOpen;
    });

    this.breakpointObserver
      .observe([
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .subscribe((result) => {
        if (result.breakpoints[Breakpoints.Small]) {
          this.sidenavMode = 'over';
          this.store.dispatch({
            type: UIActions.UI_SIDEBAR_SET_STATE,
            payload: 'close',
          });
        }
        if (result.breakpoints[Breakpoints.Medium]) {
          this.sidenavMode = 'over';
          this.store.dispatch({
            type: UIActions.UI_SIDEBAR_SET_STATE,
            payload: 'close',
          });
        }
        if (
          result.breakpoints[Breakpoints.Large] ||
          result.breakpoints[Breakpoints.XLarge]
        ) {
          this.sidenavMode = 'side';
          this.store.dispatch({
            type: UIActions.UI_SIDEBAR_SET_STATE,
            payload: 'close',
          });
        }
      });
  }

  ngOnInit(): void {
    const userData = JSON.parse(localStorage.getItem('userData'));
    this.userAvatar = userData.avatar;
    //    this.store.dispatch(getPermissionTypes());
  }
}
